export const STORAGE_KEYS = {
  REALM: 'realm',
  MAIL: 'mail',
  LANGUAGE: 'language',
  SIDENAV_OPEN: 'sidenavOpen',
  SIDENAV_WIDTH: 'sidenavWidth',
  TABS: 'tabs',
} as const;
